<div class="request">
  <div class="container">
      <div class="row">
          <div class="col-12" style="margin-top:0 !important">
              <div class="breadcrumbs">
                  <ul>
                      <li>
                          <a routerLink="/dashboard">
                          Inicio
                      </a>
                      </li>
                      <li>
                          <a routerLink="/license/extend">
                            Solicitar
                        </a>
                      </li>
                      <li>
                        <a routerLink="/license/extend">
                          Ampliar licencia
                      </a>
                      </li>
                  </ul>
              </div>
          </div>
          <div class="col-12">
              <h2 class="txt txt--title">{{requestType === 'personal' ? 'Ampliar mi licencia' : 'Ampliar licencia para un empleado o contratista'}}</h2>
              <small>Selecciona la licencia que quieres ampliar.</small>
          </div>
          <div class="request__content col-12" *ngIf="!gettingLicenses && licenses.length === 0 && gettingLicensesError === 'DEFAULT_VALUE'">
              <p class="txt txt--paragraph mb-5">Aún no tiene licencias para ampliar. Puede crear una solicitud de licencia en el botón.</p>
              <a type="button" class="btn btn--primary mb-3" routerLink="/license/new">Crear una solicitud de licencia</a>
          </div>
          <div class="loader-licenses" *ngIf="gettingLicenses">
              <app-loader style="margin-top: 20px !important;"></app-loader>
            </div>
          <div class="request__content col-12">
              <div class="border-b" style="margin-bottom:10px !important;" *ngFor="let item of licenses;index as i">
                  <app-license-card *ngIf="!gettingLicenses && licenses.length > 0 && gettingLicensesError === 'DEFAULT_VALUE'" [licensesData]="item" [zonesRows]="zonesRows" [userData]="selectedPersonData"></app-license-card>
                  <button
                  type="button"
                  class="btn btn--primary mb-3"
                  (click)="onSelectLicense(item.id, i)"
                  [attr.disabled]="shouldActiveButton[i] ? null : true"
                  [ngClass]="shouldActiveButton[i] ? '' : 'btn--disabled global-no-pointer-events'"
                  >Ampliar esta licencia</button>
                  <p class="txt txt--warning" *ngIf="isARedLicense(i)">No es posible ampliar esta licencia puesto que está {{sanctionType}}.</p>
                  <p class="txt txt--warning" *ngIf="!isARedLicense(i) && haveAnActiveRequirement[i]">No es posible crear una nueva solicitud ya que tiene una solicitud de ampliación en curso.</p>
              </div>
          </div>
      </div>
  </div>
</div>
